import { render, staticRenderFns } from "./ReleaseReport.vue?vue&type=template&id=12ec359a&"
import script from "./ReleaseReport.vue?vue&type=script&lang=js&"
export * from "./ReleaseReport.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseReport.vue?vue&type=style&index=0&id=12ec359a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports